const en = {
    Dashboard: "Home",
    Clients: "Clients",
    ClientsC: "CLIENTS",
    Client: "Client",
    ClientC: "CLIENT",
    Notes: "Notes",
    MyProfile: "My Profile",
    RoomAvailability: "Room availability",
    RoomBooking: "Room booking",
    Metrics: "Metrics",
    ExportData: "Export Data",
    Documents: "Documents",
    SearchClient: "Search client...",
    Settings: "Settings",
    SignOut: "Sign out",
    NextDeparture: "NEXT DEPARTURE",
    NextIncoming: "NEXT INCOMING",
    Incoming: "# INCOMING",
    NoDischarges: "No Discharges",
    NoUpcomingClient: "No upcoming client",
    LastClientNotes: "Last Client Notes",
    Date: "Date",
    DateC: "DATE",
    Content: "Content",
    ContentC: "CONTENT",
    Type: "TYPE",
    Edit: "Edit",
    Delete: "Delete",
    ShowMoreNotes: "Show More Notes",
    ShowLessNotes: "Show Less Notes",
    ClickHereForHelp: "Click here to get onscreen help",
    AddClient: "Add Client",
    AddTheClient: "Add the client",
    AddNewClient: "Add New Client",
    FirstName: "First Name",
    LastName: "Last Name",
    LastName2: "Last Name",
    Nickname: "Nickname",
    Gender: "Gender",
    Email: "Email",
    PhoneNumber: "Phone Number",
    Country: "Country",
    PrimaryAddiction: "Primary Addiction",
    PrimaryAddictionT: "Primary Addiction",
    DurationOfStay: "Duration of Stay",
    ETA: "ETA",
    ClientSource: "Client Source",
    ProjectedResidentialDischargeDate: "Projected Residential Discharge Date",
    ProjectedProgramCompletionDate: "Projected Program Completion Date",
    ProjectedResidentialDischargeDateRequired:
      "Projected Residential Discharge Date is required",
    ProjectedProgramCompletionDateRequired:
      "Projected Program Completion Date is required",
    PersonalInfos: "Personal Infos",
    AddictionInfos: "Addiction Infos",
    DischargeInfos: "Discharge Infos",
    FirstNameRequired: "First Name is required",
    LastNameRequired: "Last Name is required",
    NicknameRequired: "Nickname is required",
    EmailRequired: "Email is required",
    ETARequired: "ETA is required",
    Back: "Back",
    Next: "Next",
    Finish: "Finish",
    DemoTestNoClient: "Demo version : No client added :)",
    ClientName: "Client name",
    TypeQuickSessionNote: "Type quick session note here",
    NoteContent: "Note content",
    EffectiveDateTime: "Effective date and time of the note",
    EffectiveDate: "Effective date and time",
    NoteContent: "Note content",
    TypeNoteHere: "Type your note here",
    StartShift: "Start of Shift",
    TypeNoteHere: "Type your note here",
    EndShift: "End of Shift",
    SelectStaff: "Select Staff",
    EffectiveDateOnly: "Effective date",
    FamilyNoteRelationship: "Family note relationship",
    GroupTopic: "Group Topic",
    GroupDateStartTime: "Group Date and start time",
    TypeOfGroup: "Type of group",
    GroupNote: "Group note",
    TypeGroupNoteHere: "Type group note here",
    ClientsNotInAttendance: "Clients NOT in attendance",
    TypeNamesHere:
      "Type names here (first name / or preferred name and first initial of last name) and reason why client is not in group, if known...",
    ImmigrationAppointment: "Immigration appointment / visa",
    DischargesFlights: "Discharges / Flights arrangements",
    NewClients: "New clients",
    PsychiatristAppointments: "Psychiatrist Appointments",
    HospitalAppointments: "Hospital appointments",
    Outings: "Outings",
    ZoomSessionAssistance: "Zoom Session Assistance",
    StaffToday: "Staff today",
    Overnight: "Overnight",
    NumberOfClients: "Number of clients",
    Swot: "Swot",
    GeneralAnnouncement: "General announcement / Discussion",
    EditFamilyNote: "Edit Family Note",
    EditQuickNote: "Edit Quick Note",
    EditAftercareNote: "Edit Aftercare Note",
    EditGroupNote: "Edit Group Note",
    EditMedicalNote: "Edit Medical Note",
    EditSupportStaffNote: "Edit Support Staff Note",
    EditTherapyNote: "Edit Therapy Note",
    EditHandoverNote: "Edit Handover Note",
    Cancel: "Cancel",
    Save: "Save",
    TypeGroupNoteHere: "Type group note here",
    TypeMedicalNoteHere: "Type medical note here",
    ImportFile: "Import file",
    MaximumFileSize: "Maximum file size : 50 MB",
    SelectedFile: "Selected file",
    FileAlreadyUploaded: "File already uploaded",
    AreYouSureToDeleteFile: "Are you sure you want to delete this file?",
    Confirm: "Confirm",
    ConfirmDeletion: "Confirm Deletion",
    TotalRecord: "total record",
    Filters: "Filters",
    SelectClientType: "Select Client Type",
    SelectTherapist: "Select Therapist",
    SelectAddiction: "Select Addiction",
    SelectILS: "Select ILS",
    ResetFilters: "Reset Filters",
    ADDICTION: "ADDICTION",
    AKA: "AKA",
    AGE: "AGE",
    ADMISSION: "ADMISSION",
    THERAPIST: "THERAPIST",
    ROOM: "ROOM #",
    SUPPORT_STAFF: "SUPPORT STAFF",
    PleaseSelectBothDates: "Please select both start and end dates.",
    SelectRangeDate: "Select range date:",
    SeeMore: "See more",
    TO: "TO",
    RoomsAvailablePerDay: "Rooms available / day",
    DistributionPerDay: "Distribution / day",
    RoomAvailability: "Room availability",
    RoomBooking: "Room booking",
    FullscreenMode: "Fullscreen Mode",
    NoCredentials:
      "--You don't have Super-admin or Admin credentials to access this page--",
    ExitFullscreen: "Exit Fullscreen",
    TodaysDate: "Today's date",
    IncomingDischarges: "Incoming Discharges",
    NightsMo: "Nights Mo.",
    LOSToDate: "L.O.S TO DATE",
    LOSIntended: "L.O.S.(Intended)",
    TotalNightsBooked: "Total nights booked",
    TotalIncomingNights: "Total Incoming Nights",
    TotalPotentialNights: "Total Potential Nights",
    TotalProjectedNights: "Total projected nights",
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    InHouseClients: "# In-House Clients",
    BedOccRate: "Bed occ. rate",
    AvTreatmentDur: "Av. treatment dur.",
    ClientsbyAddictionTypeInhouse: "Clients by Addiction Type (Inhouse)",
    ClientsByAddictionTypeAllClients: "Clients by Addiction Type (All Clients)",
    ClientsByTherapistInhouse: "Clients by Therapist (Inhouse)",
    Day: "Days",
    Status: "Status",
    Nationality: "Nationality",
    SecondaryAddiction: "Secondary addiction",
    LengthOfStay: "Length Of Stay",
    InActiveRecovery: "In active recovery?",
    GoogleReviewDone: "Google review done?",
    ExportData: "Export Data",
    ExportData2: "Export Data",
    Documents: "Documents",
    UPLOADING: "UPLOADING...",
    UPLOAD: "UPLOAD",
    NoFileSelected: "No file selected, please select one and put a file name",
    ChooseFile: "Choose file",
    FileRequirements:
      "(one at a time, only PDF, JPG or PNG with a maximum size of 5MB)",
    UploadDocument: "Upload a document file",
    NoFilesFound: "No files found",
    NoDeletePermissions: "You don't have permissions to delete this file",
    OneFileLimit: "You can only upload one file",
    FileDeleted: "File successfully deleted!",
    ErrorDeletingFile: "Error deleting file",
    FileSizeExceedsLimit: "File size exceeds the limit:",
    FilesUploaded: "Files successfully uploaded!",
    ErrorUpdatingClient: "Error updating client:",
    NoFilesSelected: "No files selected for upload.",
    FileName: "File Name",
    TryOurAI: "Try our A.I.",
    ArtificialIntelligence: "A.I.",
    Photo: "Photo",
    Email: "Email",
    NameProfile: "Name",
    PhoneNumber: "Phone Number",
    Role: "Role",
    Profile: "Profile",
    ProfileUpdatedSuccessfully: "Profile updated successfully",
    ErrorUpdatingProfile: "Error updating profile:",
    User: "User",
    SuccessfullyLoggedOut: "successfully logged out",
    LogOut: "Log Out",
    Name: "Name",
    AskMeAnything: "Ask me anything",
    PromptInstruction:
      "In the prompt below, ask me any questions about this EHR and any questions about clients. You can ask anything in any language.",
    AnonymizedRequests:
      "All requests are anonymized (the clients' real names are not submitted to the AI model).",
    AskAbout: "Ask about:",
    HowToAddClient: "How to add a client?",
    GenerateReport: "Can I generate a report on client progress?",
    JanesProgress: "How is Jane's progress?",
    JohnsRecentNotes: "What are John's recent notes?",
    SummaryOfNotes: "Give me a summary of last week's notes.",
    NoteAddedSuccess: "Note successfully added",
    SelectedClient: "Selected client",
    NoClientSelected: "--No client selected--",
    SelectAClient: "Select a client",
    TypeNamesAndReason:
      "Type names here (first name / or preferred name and first initial of last name) and reason why client is not in group, if known...",
    IfOtherDescribe: "If other, describe",
    StartOfShift: "Start of Shift",
    EndOfShift: "End of Shift",
    SelectStaff: "Select Staff",
    Add: "Add",
    EditEndOfShiftNote: "Edit End Of Shift Note",
    WelcomeToRehabAppDemo: "Welcome to Rehab-App (Demo)",
    ContinueWithGoogle: "Continue with Google",
    LogInWithGoogle: "Log in with Google",
    InternetConnectionWorking: "Your internet connection is working",
    InternetConnectionNotWorking:
      "Your internet connection is not working. Please check your internet connection.",
    SuccessfullyLoggedInWithGoogle:
      "Successfully logged in using your Google account",
    MustLogInWithMiraclesAsiaEmail:
      "You must log in with an email address ending in @miraclesasia.com to access this application.",
    FailedToLogInWithGoogle: "Failed to log in with your Google account",
    NoRoleFoundForUser: "No role found for this user in Firestore",
    MustLogInWithGmailOrGsuite:
      "You must log in with a Gmail or G Suite address to access this application.",

    ClientNameRequired: "Client name is required",
    ContentRequired: "Content is required",
    EffectiveDateRequired: "Effective date is required",
    ImmigrationAppointmentRequired: "Immigration appointment is required",
    DischargesFlightsRequired: "Discharges / flights are required",
    NewClientsRequired: "New clients are required",
    PsychiatristAppointmentsRequired: "Psychiatrist appointments are required",
    HospitalAppointmentsRequired: "Hospital appointments are required",
    OutingsRequired: "Outings are required",
    ZoomSessionAssistanceRequired: "Zoom session assistance is required",
    StaffTodayRequired: "Staff today is required",
    OvernightRequired: "Overnight is required",
    NumberOfClientsRequired: "Number of clients is required",
    SwotRequired: "SWOT is required",
    GeneralAnnouncementRequired: "General announcement is required",
    GroupTopicRequired: "Group topic is required",
    StartTimeRequired: "Start time is required",
    GroupTypeRequired: "Group type is required",
    NotInAttendanceRequired: "Not in attendance is required",
    StartOfShiftRequired: "Start of shift is required",
    EndOfShiftRequired: "End of shift is required",
    StaffRequired: "Staff is required",
    PleaseFillAllRequiredFields: "Please fill all required fields",
    PersonalInformation: "Personal Information",
    FirstName: "First name",
    LastName: "Last name",
    Nickname: "Nickname",
    Email: "Email",
    PhoneNumber: "Phone number",
    Birthday: "Birthday",
    AgeNotEditable: "Age (not editable)",
    MaritalStatus: "Marital status",
    LivingWith: "Living with",
    IfOtherDescribe: "If other, describe",
    Gender: "Gender",
    IfOtherGenderDescribe: "If other gender, describe",
    SexualOrientation: "Sexual orientation",
    PhysicalAddressOfResidence: "Physical address of residence",
    City: "City",
    ProvinceState: "Province / State",
    Country: "Country",
    Nationality: "Nationality",
    ClientSource: "Client source",
    PassportNumber: "Passport number",
    VisaExpirationDate: "Visa expiration date",
    TreatmentInformation: "Treatment Information",
    ClientStatus: "Client status",
    RoomNumber: "Room number",
    AssignedTherapist: "Assigned Therapist",
    AssignedSupportStaff: "Assigned Support Staff",
    AdmissionAndDischarge: "Admission & Discharge",
    ActualAdmissionDate: "Actual admission date",
    ActualDischargeDate: "Actual discharge date",
    ProjectedDischargeDate: "Projected discharge date",
    ProjAftercareCompletionDate: "Proj. aftercare completion date",
    PassportPictures: "Passport Pictures",
    ImportFile: "Import File",
    MaximumFileSize: "Maximum file size: 100MB",
    UploadingFile: "Uploading file...",
    UploadedFiles: "Uploaded file(s)",
    EmergencyContact: "Emergency contact",
    EmergencyContactFirstName: "Emergency contact first name",
    EmergencyContactLastName: "Emergency contact last name",
    Relationship: "Relationship",
    IfOtherDescribe: "If other, describe",
    ContactPhoneNumber: "Contact phone number",
    ContactEmail: "Contact Email",
    PhysicalAddressOfResidence: "Physical address of residence",
    City: "City",
    Nationality: "Nationality",
    StateProvince: "State / Province",
    Country: "Country",
    PersonPayingForTreatment: "Person paying for the treatment",
    PhoneNumberOfPersonPaying: "Phone number of person paying",
    SavingModifications: "SAVING MODIFICATIONS...",
    ClickToSave: "CLICK TO SAVE",
    SaveModifications: "SAVE MODIFICATIONS",
    UploadLimitExceeded: "You can only upload up to 3 files.",
    FileSizeExceedsLimit: "File size exceeds the limit:",
    FilesSuccessfullyUploaded: "File(s) successfully uploaded!",
    FileSuccessfullyDeleted: "File successfully deleted!",
    ErrorDeletingFile: "Error deleting file",
    GeneralInformation: "General Informations",
    ActivityLogs: "Activity Logs",
    Help: "Help",
    Close: "Close",
    NoRecentActivity: "No recent activity",
    Language: "Language",
    Admin: "ADMIN",
    NoClientIdentifier: "No client identifier",
    NoTherapistAssignedYet: "No therapist assigned yet",
    AssignedTherapist: "Assigned therapist:",
    IntendedDurationOfStay: "Intended duration of stay",
    AdmissionDate: "Admission Date",
    MandatoryForms: "Mandatory forms",
    AreYouSureToDeleteFile: "Are you sure you want to delete this file?",
    AreYouSureToDeleteNote: "Are you sure you want to delete this note?",
    FileSuccessfullyDeleted: "File successfully deleted!",
    ErrorDeletingFile: "Error deleting file",
    NoteSuccessfullyDeleted: "Note successfully deleted!",
    ErrorDeletingNote: "Error deleting note:",
    Deleting: "Deleting...",
    Updating: "Updating...",
    NoRecentActivity: "No Recent Activity",
    LastModification: "Last Modification",
    ClientAddedBy: "Client Added By",
    EstimateDateOfArrival: "Estimate Date of Arrival",
    IntendedDurationOfStay: "Intended duration of stay",
    PassportStatus: "Passport status",
    PassportCopy: "Passport copy",
    PrevClientIdentifier: "Prev. client identifier",
    FlightDetails: "Flight details",
    Itinerary: "Itinerary",
    VIPTransfer: "VIP transfer",
    PaymentDetails: "Payment details",
    MaritalStatus: "Marital status",
    CurrentPartnerIfNotMarried: "If not married, current partner?",
    ChildrensOrDependents: "Childrens or dependents",
    CurrentLivingArrangements: "Current living arrangements",
    DietaryRequirements: "Dietary requirements",
    FundingSource: "Funding Source",
    PrimAddSubstOrProcAbove: "Prim. Add. (either subst. or proc. above)",
    IfOtherSelectedDescribe: "If other selected, describe",
    SecondaryAddiction: "Secondary Addiction",
    IfOtherSelectedDescribeSecondary: "If other selected, describe",
    SubstanceAddictions: "Substance Addiction(s)",
    DoCCurrentUsageLevels:
      "DoC Current Usage Levels (frequency, amount) and method (smoking, injection, snorting, orally)",
    AnyCurrentWithdrawalSymptoms: "Any Current Withdrawal Symptoms",
    ProcessAddictions: "Process Addiction(s)",
    TypeProcessAddiction:
      "type, e.g., gambling, sex, porn, food, gaming; and frequency of engaging in process addiction behavior",
    AddictionTreatmentHistory: "Addiction Treatment History",
    MainUnwantedConsequences: "Main Unwanted Consequences of Addiction",
    HowLongHasAddictionBeenAProblem:
      "How long has your using/drinking/process addiction been a problem?",
    WhatLedYouToSeekTreatmentNow: "What Led You to Seek Treatment Now?",
    TreatmentGoals: "Treatment Goals",
    BarriersForRehab: "Barriers for Rehab",
    MotivationForTreatment: "Motivation for Treatment",
    SavingModifications: "SAVING MODIFICATIONS...",
    ClickToSave: "CLICK TO SAVE",
    SaveModifications: "SAVE MODIFICATIONS",
    Addictions: "addictions",
    PreAdmissionAssessment: "Pre-Admission Assessment",
    AdmissionForms: "Admission forms",
    AuthorizationReleaseConfidentialInfo:
      "Authorization for release of confidential information",
    AddRCIForm: "Add a R.C.I. form",
    UnableToAddMandatoryForms:
      "Unable to add Mandatory forms if the client is not admitted.",
    UnableToAddROIForm:
      "Unable to add R.O.I. form if the client is not admitted.",
    CompanyIndividualName: "Company / Individual name",
    Filled: "Filled",
    Revoked: "Revoked",
    Actions: "Actions",
    Relationship: "Relationship",
    SelectedClient: "Selected Client:",
    ConfidentialityPolicyForm: "Confidentiality Policy Form",
    PleaseSignBelow: "Please sign below and click on Validate once done",
    SignatureNotValidated: "Signature not validated",
    SignatureValidated: "Signature validated!",
    Clear: "Clear",
    Validate: "Validate",
    Saving: "Saving...",
    GeneralLiabilityReleaseForm: "General Liability Release Form",
    GeneralLiabilityFormSubmitted:
      "General liability form correctly submitted!",
    ErrorAddingDocument: "Error adding document",
    InformedConsentForm: "Informed Consent Form",
    InformedConsentFormSubmitted: "Informed consent form correctly submitted!",
    ConfidentialityPolicyFormSubmitted:
      "Confidentiality policy form correctly submitted!",
    PleaseAgreeToTerms: "Please agree to all the terms before submitting.",
    Print: "Print",
    Intervention: "Intervention",
    AddTreatment: "Add Treatment",
    Adding: "Adding...",
    Objective: "Objective",
    AddObjective: "Add Objective",
    ObjectivesAssociatedInterventions:
      "Objectives and Associated Interventions Whilst in Treatment at the rehab:",
    PresentingIssues: "Presenting Issue(s):",
    LongTermGoals: "Long-Term Goals (beyond treatment at the rehab):",
    FailedToSaveTreatmentPlan:
      "Failed to save treatment plan. Please try again.",
    TreatmentPlanSuccessfullyAdded: "Treatment plan successfully added!",
    PleaseFillRequiredFields: "Please fill in all required fields.",
    ObjectiveIntervention: "Objective / Intervention",
    TreatmentPlan: "Treatment Plan",
    DischargeSummary: "Discharge summary",
    DischargeDate: "Discharge date",
    DischargeType: "Discharge type",
    DischargeTo: "Discharge to",
    DateOfAdmission: "Date of admission",
    TotalLengthOfStay: "Total length of stay",
    MedicationPrescribedUponDischarge: "Medication prescribed upon discharge",
    IdentifiedIssuesUponAdmission: "Identified issues upon admission",
    EmergingIssuesDuringTreatment:
      "Emerging issues identified during treatment",
    OverallLevelOfEngagement: "Overall level of engagement in the program",
    Resistance: "Resistance",
    HighlyEngaged: "Highly engaged",
    Progress: "Progress",
    FamilyInvolvement: "Family / significant Other Involvement",
    RoadblocksConcerns: "Roadblocks/Concerns",
    ClientPrognosis: "Client prognosis",
    RecommendedDischargePlan: "Recommended Discharge Plan",
    StaffMemberName: "Staff Member Name",
    Submit: "Submit",
    LeaveAgainstClinicalAdvice: "Leave Against Clinical Advice (ACA)",
    EmergencyDischarge: "Emergency Discharge",
    TreatmentPlanFor: "Treatment Plan for:",
    EditTreatmentPlan: "Edit Treatment Plan",
    Review: "Review",
    TypeReviewHere: "Type review here",
    AddReviews: "Add Reviews",
    UpdateReviews: "UPDATE REVIEWS",
    Updating: "UPDATING...",
    ObjectiveReviewsUpdated: "Objective reviews successfully updated!",
    FailedToUpdateObjectiveReviews:
      "Failed to update objective reviews. Please try again.",
    TreatmentPlanUpdated: "Treatment plan successfully updated!",
    FailedToSaveTreatmentPlan:
      "Failed to save treatment plan. Please try again.",
    SelectNoteType: "Select Note Type",
    StartDate: "Start Date",
    EndDate: "End Date",
    AddNote: "Add Note",
    TotalNote: "Total Note",
    GeneralDocuments: "General Documents",
    TherapistsDocuments: "Therapists Documents",
    CRM: "CRM",
    Medication: "Medication",
    Invoicing: "Invoicing",
    Support: "Support",
    AddAlert: "Add Alert",
    EditAlert: "Edit Alert",
    PleaseSelectTypeAndContent:
      "Please select a type and enter content for the alert",
    ConfirmDeleteAlert: "Are you sure you want to delete the alert?",
    ShowMore: "Show more",
    ShowLess: "Show less",
    Alerts: "ALERTS",
    ClinicalInformations: "Clinical Informations",
    AddTreatmentPlan: "Add Treatment Plan",
    NoTreatmentPlanAdded:
      "NO TREATMENT PLAN ADDED. PLEASE ADD A TREATMENT PLAN",
    Added: "Added",
    Reviewed: "Reviewed",
    DischargeForms: "Discharge forms",
    PrimaryAddictionColon: "Primary Addiction:",
    NoPrimaryAddictionRecorded: "No primary addiction recorded",
    NoAdmissionDateYet: "No admission date yet",
    NoDurationOfStayYet: "No duration of stay yet",
    YearsOld: "years old",
    ClientProfile: "Client profile",
    DateOfBirth: "Date of birth",
    DateOfBirthRequired: "Date of Birth is required",
    Create: "Create",
    AddNewLead: "Add New Lead",
    UpdateLead: "Update Lead",
    PhoneNumberRequired: "Phone number is required",
    FailedToCreateOrUpdateLead:
      "Failed to create/update lead. Please try again.",
    LeadUpdatedSuccessfully: "Lead updated successfully!",
    LeadCreatedSuccessfully: "Lead created successfully!",

    AddNewTicket: "Add new ticket",
    WriteDescription: "Write a description of your problem below",
    UploadScreenshots:
      "Upload screenshot(s) of the issue below if you have some",
    TicketName: "Ticket Name",
    Priority: "Priority",
    TicketType: "Ticket type",
    Medium: "Medium",
    Low: "Low",
    High: "High",
    PageConcerned: "Page concerned",
    AgeNonEditable: "Age (non editable)",
    PreviousWeek: "Previous Week",
    NextWeek: "Next Week",
    MandatoryFormsSection:
      "This is the 'Mandatory forms' section where you can add, view, and manage all the essential forms that are required for the client's admission and treatment process. Ensure that all necessary documents are completed and up-to-date to comply with regulations and provide comprehensive care.",
    AuthorizationSection:
      "This is the 'Authorization for release of confidential information' section. Here, you have the ability to manage and add new authorization forms that allow the release of a client's confidential information to authorized parties. It's important to handle these documents carefully to maintain privacy and adhere to legal requirements.",
    SearchBar:
      "This is the search bar where you can search for clients by entering their name or other relevant information. It helps you quickly locate and access a client's details, making your workflow more efficient.",
    AIServicePrompt:
      "Try our AI service here! This feature leverages advanced artificial intelligence to assist you in various tasks, making your experience smoother and more intuitive. Click here to explore how AI can enhance your productivity and offer smart solutions.",
    ProfileWidget:
      "This is your profile widget where you can manage your account settings, view your profile information, and access personal preferences. It provides a quick way to customize your experience and stay updated with your account details.",
    InHouseClientsInfo:
      "Here you can see the total number of clients who are currently in-house. Click on this widget for more details about these clients.",
    NextClientDepartureInfo:
      "This widget displays the next client scheduled for departure, including their name and planned discharge date. Click to view more information about this client.",
    NextIncomingClientInfo:
      "This widget shows the next incoming client, with their expected arrival date. Click to learn more about this incoming client.",
    UpcomingClientsInfo:
      "This widget presents the total number of clients who are scheduled to arrive soon. Click for more details about these upcoming clients.",
    DashboardHelp:
      "Access the dashboard for an overview of activities and key statistics.",
    ClientsHelp:
      "Manage all clients by type (In House, Aftercare, Incoming, etc.).",
    NotesHelp:
      "View and filter notes by type to keep track of client interactions.",
    RoomAvailabilityHelp: "View the number of available rooms per day.",
    RoomBookingHelp:
      "See detailed daily bookings with client names and specific details.",
    CRMHelp:
      "Present a kanban with client cards by status, allowing you to manage lead qualification progress.",
    MetricsHelp: "Show various metrics and statistics.",
    ExportDataHelp:
      "Export client data in case the client wants to retrieve their data.",
    DocumentsHelp: "Store documents accessible to all other users.",
    SupportHelp: "Send tickets to support for assistance.",
    LatestSupportTickets: "Latest Support Tickets",
    NoTicketsFound: "No tickets found",
    Reset: "Reset",
    PleaseSendTicket: "Please send us a ticket about any issue you have",
    SupportTickets: "Support tickets",
    WelcomeToRehappApp: "Welcome to Rehapp",
    AskMeExample: "Ask me, for example",
    GiveMeInhouseClientsList: "Give me the list of Inhouse clients",
    WhatIsNextBirthday: "What is the next birthday",
    SummarizeLatestNotes: "Summarize the latest notes",
    WhereCanISeeInhouseClientsList:
      "Where can I see the list of Inhouse clients",
    RoleManagement: "Role management",
    SuperAdminSubtitle:
      "As a Super Admin, you can modify the role of each user",
    TotalRecord: "Total record",
    NoSuperAdminAccess:
      "You don't have Super-admin credentials to access this page",
    GoogleEmail: "Google email",
    UserName: "User Name",
    UserRole: "User Role",
    PhoneNumber: "Phone Number",
    Actions: "Actions",
  };

export default en;
